import { render, staticRenderFns } from "./Nutbody.vue?vue&type=template&id=eccb374c&scoped=true&"
import script from "./Nutbody.vue?vue&type=script&lang=js&"
export * from "./Nutbody.vue?vue&type=script&lang=js&"
import style0 from "./Nutbody.vue?vue&type=style&index=0&id=eccb374c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccb374c",
  null
  
)

export default component.exports